const getLanguage = (): string => {
  return window.navigator.language;
};

export default getLanguage;